<template>
    <header>
        <h2 :class="titleClasses" v-text="title" />
    </header>
</template>
<script setup>
import { computed } from 'vue';

const props = defineProps({
    title: String,
    variant: {
        type: String,
        default: 'default',
    },
    headingClasses: {
        type: [Array, Object, String],
        default: null,
    },
});

const titleClasses = computed(() => [
    'mb-sm-0 mb-2 min-h-8 leading-8',
    props.variant === 'inverse' ? '!text-white !font-normal' : '!font-semibold !text-gray-body',
    props.headingClasses,
]);
</script>
